import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as api from 'api/methods';

import { Loading } from 'components/shared/Loading';

import PromocodeActivationsChart from './PromocodeActivationsChart';
import type { PromocodeActivationStatsItem } from './PromocodeActivationsChart.helpers';

const PromocodeActivationsChartContainer = ({
  schoolId,
}: {
  schoolId: string;
}) => {
  const { i18n } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState<PromocodeActivationStatsItem[]>([]);

  useEffect(() => {
    const loadActivationStats = async () => {
      try {
        const response = (await api.getSchoolCodeActivationStats({
          schoolId,
        })) as { data: PromocodeActivationStatsItem[] };

        setStats(response.data ?? []);
      } catch (error) {
        console.warn(error);
        setStats([]);
      }

      setLoading(false);
    };

    setLoading(true);
    loadActivationStats();
  }, [schoolId]);

  if (loading) {
    return <Loading />;
  }

  return (
    <PromocodeActivationsChart locale={i18n.language} stats={stats} />
  );
};

export default React.memo(PromocodeActivationsChartContainer);
